import '../sass/Projects.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRocket, faShieldHalved, faVial, faBug, faMagnifyingGlass, faUsers, faBolt, faGlobe, faCode, faClipboardList } from '@fortawesome/free-solid-svg-icons'

const projects = [
    {
        title: 'TMT – Training Management Tool',
        badge: 'Projet de fin de master',
        description: "Outil de gestion interne développé pour un organisme de formation. TMT centralise les données liées aux formations (clients, formateurs, sessions, conventions) et automatise la génération des documents PDF, leur envoi par e-mail aux clients et leur archivage sur un Google Drive d'entreprise.",
        stack: ['Angular', 'Symfony', 'PostgreSQL', 'Docker', 'GitLab CI/CD', 'JWT', 'Google Drive API', 'Sentry'],
        highlights: [
            {
                icon: faRocket,
                label: 'Architecture & Déploiement',
                text: "Architecture 3 tiers (Angular + API REST Symfony + PostgreSQL) conteneurisée avec Docker Compose, déployée sur un VPS OVH. Pipeline CI/CD GitLab avec stages lint, build, test et deploy automatique sur la branche main.",
            },
            {
                icon: faShieldHalved,
                label: 'Sécurité',
                text: "Mesures alignées sur l'OWASP Top 10 : JWT HttpOnly/SameSite=Strict, blocklist JWT, rate limiting, PHPStan niveau 8, headers sécurité, Gitleaks et SAST intégrés à la pipeline.",
            },
            {
                icon: faVial,
                label: 'Tests & Qualité',
                text: "219 tests backend PHPUnit (75,07 % de coverage) et 178 tests frontend Karma/Jasmine (94,69 %). 131 scénarios de recette. Coverage minimal imposé et vérifié automatiquement à chaque commit.",
            },
            {
                icon: faBug,
                label: 'Problème résolu en production',
                text: "Bug bloquant : suppression d'un formateur déclenchant une violation de contrainte PostgreSQL. Analysé via logs Docker et Sentry, corrigé par suppression en cascade sur les entités liées (formateur inactif sans sessions à venir), redéployé via la pipeline.",
            },
        ],
        stats: [
            { value: '219', label: 'tests backend' },
            { value: '94,69 %', label: 'coverage frontend' },
        ],
    },
    {
        title: 'Efektiv Académie',
        badge: 'Voltaire Digital • Audit & Qualité',
        description: "Plateforme d'e-learning déjà en production au moment de mon intervention. Mission principale : réaliser un audit de code complet, identifier les failles et les manquements aux bonnes pratiques, puis piloter leur correction avec l'équipe de développement. Ce projet est à l'origine de la démarche qualité déployée sur l'ensemble des projets de l'entreprise.",
        stack: ['Laravel', 'React','Docker', 'Github Actions', 'Gitleaks', 'Semgrep (SAST)', 'Dependabot', 'PHPUnit'],
        highlights: [
            {
                icon: faMagnifyingGlass,
                label: 'Audit de l\'existant',
                text: "Code review complet ayant identifié 9 points critiques : absence de CI/CD, .env versionné sur Git, pas de rate limiter, pas de tests unitaires, verbes HTTP incorrects, absence de linter et de règles de validation, branche Git unique.",
            },
            {
                icon: faShieldHalved,
                label: 'Mise en place qualité & sécurité',
                text: "Construction d'une matrice de qualité devenue référentiel commun de l'entreprise. Implémentation d'une pipeline CI/CD (lint, tests, audit dépendances, Gitleaks, SAST) et d'une stratégie de branches. Coverage minimal de 70 % imposé.",
            },
            {
                icon: faUsers,
                label: 'Conduite du changement',
                text: "Présentation des résultats d'audit à la direction, puis communication régulière avec l'équipe pour suivre la correction des failles. Résistance à la CI/CD surmontée en démontrant concrètement les risques évités.",
            },
        ],
        stats: [
            { value: '9', label: 'points d\'audit identifiés' },
            { value: '70 %', label: 'coverage minimal imposé' },
            { value: '1er', label: 'projet CI/CD de l\'entreprise' },
        ],
    },
    {
        title: 'OPDO',
        badge: 'Voltaire Digital • Pilotage de projet',
        description: "Outil de gestion pour l'assurance dommages ouvrages. Mission de pilotage de projet sans intervention sur le code : structuration de la méthodologie de travail, mise en place d'automatisations et coordination avec une équipe de développeurs internationale.",
        stack: ['Jira', 'Monday', 'Slack', 'Kanban'],
        highlights: [
            {
                icon: faClipboardList,
                label: 'Structuration Kanban',
                text: "Mise en place d'une méthode Kanban sur un projet sans méthodologie de suivi. Chaque tâche trackée de manière centralisée, remplaçant une répartition informelle qui ne permettait pas d'estimer l'avancement réel.",
            },
            {
                icon: faBolt,
                label: 'Automatisations Jira',
                text: "Création d'automatisations Jira : notification Slack à chaque changement de colonne, et synchronisation des tickets avec Monday (outil du service commercial). Résolution d'un conflit d'accès aux données entre service technique et commercial.",
            },
            {
                icon: faGlobe,
                label: 'Coordination internationale',
                text: "Communication quotidienne en anglais avec l'équipe de développement. Application des guides de bonnes pratiques élaborés sur Efektiv Académie, adaptés aux contraintes de confidentialité de l'assurance construction.",
            },
        ],
        stats: [
            { value: '3', label: 'outils synchronisés' },
        ],
    },
    {
        title: 'Application de suivi client',
        badge: 'Stage NOOUS',
        description: "Développement d'un outil de gestion de clients en Symfony lors d'un stage de 6 semaines. Premier projet professionnel en Symfony, réalisé en autonomie après une phase de montée en compétences sur le framework.",
        stack: ['Symfony', 'PHP', 'MySQL'],
        highlights: [
            {
                icon: faCode,
                label: 'Développement from scratch',
                text: "Conception et développement d'un outil permettant de répertorier et gérer les clients de l'entreprise. Prise en main de Symfony en conditions réelles sur un projet livré au client.",
            },
        ],
        stats: [],
    },
]

function Projects() {
    return (
        <div className="projects" id="projects">
            <h2 className="projects-title">MES RÉALISATIONS :</h2>
            <div className="projects-list">
                {projects.map((project, i) => (
                    <div className="project-card" key={i}>
                        <div className="project-header">
                            <h3>{project.title}</h3>
                            <span className="project-badge">{project.badge}</span>
                        </div>
                        <p className="project-description">{project.description}</p>
                        <div className="project-stack">
                            {project.stack.map(tech => (
                                <span className="stack-tag" key={tech}>{tech}</span>
                            ))}
                        </div>
                        <div className="project-highlights">
                            {project.highlights.map((h, j) => (
                                <div className="highlight-item" key={j}>
                                    <div className="highlight-icon">
                                        <FontAwesomeIcon icon={h.icon} size="lg" style={{ color: '#2965FF' }} />
                                    </div>
                                    <div className="highlight-content">
                                        <strong>{h.label}</strong>
                                        <p>{h.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {project.stats.length > 0 && (
                            <div className="project-stats">
                                {project.stats.map((s, k) => (
                                    <div className="stat-item" key={k}>
                                        <span className="stat-value">{s.value}</span>
                                        <span className="stat-label">{s.label}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Projects
